import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as appActions from "../../actions/appactions";
import * as menuConstants from "../../constants/menuConstants";
import * as appConstants from "../../overrides/appconstants";
import * as sharedConstants from "../../constants/sharedContants";
import securityService from "../../services/securityservice";
import * as secuityActions from "../../actions/securityactions"
export default function LeftSideMenu() {

  const securityState = useSelector((state) => state.securityReducer);
    let navigate = useNavigate();
  let dispatch= useDispatch();
    const handleModuleOpen = (menuId, url, e) => {
        e.preventDefault();
        if (appConstants.SYSTEM_ID === 1) {
          //  window.location.href = securityService.getSystemUrl(securityState.userSession.menus, menuId) + url;
          dispatch(secuityActions.redirectToPage(menuId));
        } else {
            navigate('/' + url);
        }
    };
    function renderDynamicMenu1() {
        let modules = null;
        let systemMenu = null;
        let pages = null;
        let userSession = securityState.userSession;
        if (userSession == null) {
            return <div></div>;
        }
        let userMenu = userSession.menus;
        console.log("userMenu", userMenu);
        let isMiBrokerUser = !Object.values(sharedConstants.ALLOWED_USERS).includes(userSession.userId)   && //!= "ADMIN" &&
            userSession.menus.find(p => p.menuId === 295) != undefined;
        return (
            <>
                {(systemMenu = userMenu.filter(
                    (p) => p.menuType === menuConstants.MENU_TYPE_SYSTEM
                    &&  (
                        appConstants.SYSTEM_ID==sharedConstants.SYSTEM_IDS.SSO
                        ||
                        p.menuId==appConstants.SYSTEM_MENU_ID
                    )
                    && (p.menuId!==1||isMiBrokerUser==false)
                )) &&
                    systemMenu.map((sys, index) => (
                        <>
                            <a data-bs-toggle="collapse"
                                href={`#sys-${sys.menuId}`}
                                aria-expanded="false"
                                aria-controls={`sys-${sys.menuId}`}
                                class="side-nav-link"
                                key={sys.menuId}>

                                <i class="uil-folder-plus"></i>
                                <span> {sys.displayName} </span>
                                <span class="menu-arrow"></span>
                            </a>
                            <div class="collapse" id={`sys-${sys.menuId}`}>
                                <ul class="side-nav-second-level">
                                    <li class="side-nav-item">
                                        {(modules = userMenu.filter(
                                            (p) =>
                                                p.menuType === menuConstants.MENU_TYPE_MODULE &&
                                                p.parentMenuId === sys.menuId
                                        )) &&
                                            modules.map((mod, index) => (
                                                <>
                                                    <a data-bs-toggle="collapse"
                                                        href={`#mod-${mod.menuId}`}
                                                        aria-expanded="false"
                                                        aria-controls={`mod-${mod.menuId}`}
                                                    >
                                                        <span> {mod.displayName} </span>
                                                        <span class="menu-arrow"></span>
                                                    </a>
                                                    <div class="collapse" id={`mod-${mod.menuId}`}>
                                                        <ul class="side-nav-third-level">
                                                            {(pages = userMenu.filter(
                                                                (p) =>
                                                                    p.menuType === menuConstants.MENU_TYPE_PAGE &&
                                                                    p.parentMenuId === mod.menuId
																	&& p.visibleYN!='N'
                                                            )) &&
                                                                pages.map((page) => (
                                                                    <li key={page.menuId}>
                                                                        <a
                                                                            key={page.menuId}
                                                                            href="javascript: void(0);"
                                                                            onClick={(e) => handleModuleOpen(page.menuId, page.url, e)}
                                                                        >
                                                                            {page.displayName}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                        </ul>
                                                    </div>
                                                </>
                                            ))

                                        }
                                    </li>
                                </ul>
                            </div>
                        </>
                    ))
                }
            </>
        )
    }

  return (
    /*!-- ========== Left Sidebar Start ========== --*/
    <div class="leftside-menu">
       
      {/*-- LOGO --*/}
      <a href="#" class="logo text-center logo-light">
        <span class="logo-lg">
          <img src="content/theme/assets/images/newlogo.png" alt="" height="50" />
        </span>
        <span class="logo-sm">
          <img src="content/theme/assets/images/logohead.png" alt="" height="40" />
        </span>
      </a>

      {/*-- LOGO -->*/}
      <a href="#" class="logo text-center logo-dark">
        <span class="logo-lg">
        <img src="content/theme/assets/images/newlogo.png" alt="" height="45" />
        </span>
        <span class="logo-sm">
        <img src="content/theme/assets/images/logohead.png" alt="" height="35" />
        </span>
      </a>

      <div class="h-100" id="leftside-menu-container" data-simplebar>
        
        {/*!--- Sidemenu -->*/}
        <ul class="side-nav">
          <li class="side-nav-title side-nav-item">Navigation</li>
          <li class="side-nav-item">
          {renderDynamicMenu1()}
          </li>

        </ul>
      </div>

    </div>
  )
}
